import BaseModelAPI from '../BaseModelAPI';

export default class ApprovalHistoryList extends BaseModelAPI {

	static entity = 'approvalhistorylist'
	static entityName = 'approvalhistory';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
